import React from "react";

const FilterIcon = ({ fill = "#344054", height = "14px", width = "14px" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8333 1.75H1.16666L5.83332 7.26833V11.0833L8.16666 12.25V7.26833L12.8333 1.75Z"
        stroke={fill}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FilterIcon;
